import { watch, shallowRef, getCurrentInstance, computed } from 'vue'
import { get, transformColumn, filters } from '../../../utils/index'
import { useTemplate } from '../../../hooks/index'

export function useColumn(props, tableRef, compileSource, emit) {
  const { proxy } = getCurrentInstance()
  const { compileData, getTemplateData } = useTemplate()
  const strategy = computed(() => proxy?.$store?.state.strategy?.strategy ?? {})
  const tableConfig = shallowRef(null)
  const columnList = shallowRef([])
  const validRules = shallowRef({})
  const getColumn = async () => {
    const tableConfigDefault = {
      total: false,
    }
    if (props.column) {
      const { columns, rules } = transformColumn(
        Array.isArray(props.column) ? props.column : props.column?.items ?? [],
        strategy.value,
        {
          compileSource,
          compileData,
          getTemplateData,
        }
      )
      columnList.value = columns
      validRules.value = rules
      tableConfig.value = Array.isArray(props.column) ? tableConfigDefault : props.column?.table
    } else if (props.columnTableCode) {
      const [resData] = await get(`${props.columnUrl}${props.columnTableCode}`)
      const { columns, rules } = transformColumn(resData?.data?.items ?? [], strategy.value, {
        compileSource,
        compileData,
        getTemplateData,
      })
      columnList.value = columns
      validRules.value = rules
      tableConfig.value = resData?.data?.table ?? tableConfigDefault
    } else {
      columnList.value = []
      validRules.value = {}
      tableConfig.value = null
    }
    emit('column-change', { columnList: columnList.value, tableConfig: tableConfig.value })
  }
  watch([() => props.columnTableCode, () => props.columnUrl, () => props.column], getColumn, {
    immediate: true,
  })

  const columnShow = (column, extendCompileData) => {
    const showReg = column.show ? compileData(column.show, extendCompileData) : true
    return column.visible && showReg
  }

  const formatter = ({ cellValue, column, row }) => {
    const parameter = column.params?.parameter
    if (
      !row.master &&
      props.masterNotShowFields &&
      props.masterNotShowFields.includes(column.params.property)
    ) {
      return '-'
    } else if (props.treeNode && row.children?.length > 0 && parameter?.parentHide) {
      return '-'
    } else if (props.treeNode && row._PARENT && parameter?.childHide) {
      return '-'
    } else {
      const parameter = column.params?.parameter
      const propsValue = parameter?.value
        ? compileData(parameter.value, { ...compileSource, row })
        : parameter?.value
      const resVal = propsValue ?? cellValue ?? '-'
      return resVal === '-' || resVal === ''
        ? '-'
        : filters(resVal, parameter?.type, parameter?.format, parameter?.symbol)
    }
  }

  const columnCustom = () => {
    if (props.columnTableCode && !props.column) {
      getColumn()
    }
    emit('column-custom')
  }

  return {
    tableConfig,
    columnList,
    columnCustom,
    validRules,
    columnShow,
    formatter,
  }
}
